var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window",class:[_vm.classes]},_vm._l((_vm.steps),function(step){return _c('div',{key:step,staticClass:"window-item"},[(_vm.active === step)?_vm._t(("" + step)):_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }